export const verificationStatus = {
  verificationRequestStatusNew: () => 'new',
  verificationRequestStatusAccepted: () => 'accepted',
  verificationRequestStatusRejected: () => 'rejected',
  verificationRequestStatusExpired: () => 'expired',
}
export const verificationType = {
  verificationRequestTypeVerification: () => 'verification',
  verificationRequestTypeProfileChange: () => 'profile_change',
  verificationRequestTypeUpdatingDocument: () => 'updating_document',
}

export const getBadge = (status: string) => {
  switch (status) {
    case 'new':
      return 'success'
    case 'false':
      return 'danger'
    case undefined:
    case 'reject':
      return 'danger'
    default:
      return 'primary'
  }
}

export const verificationRejectReason = {
  uploadIdPassportDriversLicense: {
    label:
      'Please upload a copy of your government issued ID, passport or driver’s license.',
    key: 'reason-verification-rejection.upload-id-passport-drivers-license',
  },
  uploadIdPassport: {
    label: 'Please upload a copy of your government issued ID or passport.',
    key: 'reason-verification-rejection.upload-id-passport',
  },
  alreadyHaveVerifiedPersonalArea: {
    label:
      'You already have a verified Personal Area. Please use the verified Personal Area or contact support at care@hw.site',
    key: 'reason-verification-rejection.already-have-verified-personal-area',
  },
  photoIsPoorQuality: {
    label:
      'The photo uploaded is of poor quality. Please, upload a better quality photo or choose a different format.',
    key: 'reason-verification-rejection.photo-is-poor-quality',
  },
  documentDataNotVisible: {
    label:
      'The data in the document is not clearly visible. Please upload again.',
    key: 'reason-verification-rejection.document-data-is-not-clearly-visible',
  },
  documentPhotoEdited: {
    label:
      'The document photo(s) have been edited. Please upload the original document without any graphical editing.',
    key: 'reason-verification-rejection.document-photo-have-been-edited',
  },
  documentExpired: {
    label: 'The document uploaded has expired. Please upload a valid document.',
    key: 'reason-verification-rejection.document-is-expired',
  },
  documentDamaged: {
    label:
      'The uploaded document is damaged. Please upload a different document.',
    key: 'reason-verification-rejection.document-is-damaged',
  },
  documentMissingRequiredData: {
    label:
      'The uploaded document is missing the full name, date of birth, your photo and/or document number. Please upload a different document.',
    key: 'reason-verification-rejection.document-is-missing-required-data',
  },
  documentMissingRecognizablePhoto: {
    label:
      'The uploaded document is missing a recognizable photo of the owner. Please upload a document with a clear photo of your face.',
    key: 'reason-verification-rejection.document-is-missing-recognizable-photo',
  },
  needSelfieWithDocument: {
    label:
      'To confirm your identity, please, upload a selfie photo of you holding the document near your face. Ensure that all the information on the document is clearly visible and that your entire arm, including the elbow, holding the ID is fully visible in the photo.',
    key: 'reason-verification-rejection.need-selfie-photo-with-document',
  },
  documentNotFromRegistrationCountry: {
    label:
      'The uploaded document is not from the country/region where your Personal Area is registered. Please upload a copy of your utility bill or bank statement for proof of address.',
    key: 'reason-verification-rejection.document-is-not-from-registration-country',
  },
  cornersNotVisible: {
    label: 'The corners of the document are not visible. Please upload again.',
    key: 'reason-verification-rejection.corners-are-not-visible',
  },
  documentMissingPage: {
    label:
      'The document is missing either the front or back page. Please upload both sides of the document.',
    key: 'reason-verification-rejection.document-is-missing-page',
  },
  uploadAdditionalDocumentWithDob: {
    label: 'Please upload an additional document with your date of birth.',
    key: 'reason-verification-rejection.upload-additional-document-with-date-of-birth',
  },
  forbiddenDocumentCountry: {
    label:
      'Unfortunately, we do not accept clients from the country of the uploaded document. If you have any questions, please contact us at care@hw.site.',
    key: 'reason-verification-rejection.forbidden-document-country',
  },
  under18YearsClient: {
    label:
      'Unfortunately, we do not accept clients that are under 18 years of age.',
    key: 'reason-verification-rejection.under-18-years-client',
  },
  needDocumentWithNameAndAddress: {
    label:
      'Please upload an additional document with your name and address (utility bill or bank statement).',
    key: 'reason-verification-rejection.need-additional-document-with-name-and-address',
  },
  enterFullNameCorrectly: {
    label: 'Please enter the full name correctly per your document.',
    key: 'reason-verification-rejection.enter-full-name-correctly',
  },
  enterFullNameAndDocumentNumberCorrectly: {
    label:
      'Please enter the full name and document number correctly per your document.',
    key: 'reason-verification-rejection.enter-full-name-and-document-number-correctly',
  },
  enterDocumentNumberCorrectly: {
    label: 'Please enter the document number correctly per your document.',
    key: 'reason-verification-rejection.enter-document-number-correctly',
  },
  uploadDigitalNinSlip: {
    label:
      'Please upload your digital NIN slip where the NIN number is visible.',
    key: 'reason-verification-rejection.upload-digital-nin-slip',
  },
  nameMismatchWithBirthCertificate: {
    label: 'The name on the document and birth certificate do not match.',
    key: 'reason-verification-rejection.name-on-document-and-birth-certificate-do-not-match',
  },
  fundsOnVerifiedPA: {
    label:
      'You have funds on your verified Personal Area. Please make a withdrawal or contact us at care@hw.site to accept the losses.',
    key: 'reason-verification-rejection.have-funds-on-verified-personal-area',
  },
  documentProofOnlyAddress: {
    label:
      'This document can only be used as proof of address - please upload your government issued ID or passport.',
    key: 'reason-verification-rejection.document-proof-only-address',
  },
  needColorPhoto: {
    label: 'Please upload a copy of the original document in color.',
    key: 'reason-verification-rejection.need-document-color-photo',
  },
  needPhysicalCopy: {
    label: 'Please upload the physical copy of document (not digital).',
    key: 'reason-verification-rejection.need-physical-copy-of-document',
  },
  infoNotVisible: {
    label:
      'Information is not clearly visible. Please retake the photo in good lighting and without flash.',
    key: 'reason-verification-rejection.information-is-not-clearly-visible',
  },
  newPersonalAreaRegistration: {
    label: 'New Personal Area registration.',
    key: 'reason-verification-rejection.new-personal-area-registration',
  },
  alreadyVerifiedPA: {
    label: 'The Personal Area is already verified.',
    key: 'reason-verification-rejection.already-verified',
  },
  contactSupport: {
    label: 'Please contact us at care@hw.site',
    key: 'reason-verification-rejection.contact-support',
  },
  otherReason: {
    label: 'Other Reason',
    key: 'reason-verification-rejection.other-reason',
  },
}

export enum SystemComment {
  AUTO_REJECTED_BY_DUPLICATE = 'auto_rejected_by_duplicate',
}
